export enum actionTypes {
  NOMBRE_EMPRESA_FETCH = 'NOMBRE_EMPRESA_FETCH',
  NOMBRE_EMPRESA_SUCCESS = 'NOMBRE_EMPRESA_SUCCESS',
  NOMBRE_EMPRESA_ERROR = 'NOMBRE_EMPRESA_ERROR',
}

export enum NombreEmpresaStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface NombreEmpresa {
  id: number
  nombre: string
  urlLogo: string
}

export interface NombreEmpresaState {
  status: NombreEmpresaStatus
  nombresEmpresa: NombreEmpresa[]
}

export interface NombreEmpresaFetch {
  type: typeof actionTypes.NOMBRE_EMPRESA_FETCH
  payload: []
}

export interface NombreEmpresaSuccess {
  type: typeof actionTypes.NOMBRE_EMPRESA_SUCCESS
  payload: NombreEmpresa[]
}

export interface NombreEmpresaError {
  type: typeof actionTypes.NOMBRE_EMPRESA_ERROR
  payload: []
}

export type NombreEmpresaActions = NombreEmpresaFetch | NombreEmpresaSuccess | NombreEmpresaError

export const initialState: NombreEmpresaState = {
  status: NombreEmpresaStatus.Idle,
  nombresEmpresa: [],
}
